module.exports = __webpack_public_path__ + "img/doc_empty.ca5f124f.svg";